let originUrl = window.location.origin;
let baseURL = originUrl.includes("localhost") ? process.env.REACT_APP_API_URL : `${originUrl}/api`;

export const mcpModuleURL = {
  connections: baseURL + '/integration-services/mcp/connections',
  authorize: baseURL + '/integration-services/mcp/authorize',
  deleteConnection: baseURL + '/integration-services/mcp/delete',
};

export const userModuleURL = {
  facebookLoginUrl: baseURL + 'facebookLogin',
  login: baseURL + '/profile-master-services/public/login',
  register: baseURL + '/profile-master-services/public/create-account',
  resetPassword: baseURL + '/profile-master-services/public/forget-password',
  changePasswordRequest: baseURL + '/profile-master-services/public/change-password-request',
  sendAuthCodeToServer: baseURL + '/profile-master-services/public/google-signup',
  logout: baseURL + '/profile-master-services/private/logout',
  fetchUserDetails: baseURL + '/profile-master-services/private/fetch-user-details',
  updateUserDetails: baseURL + '/profile-master-services/private/update-user-details',
  updatePasswordRequest: baseURL + '/profile-master-services/private/update-password',
  getAllUserList: baseURL + '/profile-master-services/private/get-all-users',
  deleteUser: baseURL + '/profile-master-services/private/delete-user?id=',
  verifyUser: baseURL + '/profile-master-services/public/verify-user',
  fetchNotification: baseURL + '/notification-services/fetch-notification',
  updateNotification: baseURL + '/notification-services/update-read-receipts',
  getPageDetails: baseURL + '/profile-master-services/private/get-page-details',
  resendVerificationMail: baseURL + '/profile-master-services/private/resend-verify-email',
  getB2SSupportChatResponse: baseURL + '/profile-master-services/public/get-b2s-support-chat-response',
  sendSupportEmail: baseURL + '/profile-master-services/public/send-support-email',
  getAllPlan: baseURL + '/payment-services/get-all-plans?timezone=',
  appSumoRegisteration: baseURL + '/profile-master-services/public/create-appsumo-account',
  affiliateRegisteration: baseURL + '/profile-master-services/public/create-affiliate-account',
  couponVerify: baseURL + '/profile-master-services/public/coupon-verify',
  getAllBrands: baseURL + '/profile-master-services/private/get-all-brands',
  fetchUsersBrand: baseURL + '/profile-master-services/private/fetch-users-brand',
  intialLoad: baseURL + '/profile-master-services/private/initial-load',
  updateConversionFlag: baseURL + '/profile-master-services/private/update-conversion-flag',
  createNewBrand: baseURL + '/profile-master-services/private/create-new-brand',
  updateBrand: baseURL + '/profile-master-services/private/update-brand-details',
  leaveBrand: baseURL + '/profile-master-services/private/leave-from-brand',
  leaveOrganization: baseURL + '/profile-master-services/private/leave-from-org',
  deleteBrand: baseURL + '/profile-master-services/private/delete-brand',
  getAllRoles: baseURL + '/profile-master-services/private/fetch-all-roles',
  enableScheduledPost: baseURL + '/integration-services/enable-scheduled-event',
  enableOrgScheduledPost: baseURL + '/integration-services/enable-org-scheduled-event',
  disableScheduledPost: baseURL + '/integration-services/disable-scheduled-event',
  disableOrgScheduledPost: baseURL + '/integration-services/disable-org-scheduled-event',
  disableUser: baseURL + '/profile-master-services/private/disable-user',
  enableBrandUser: baseURL + '/profile-master-services/private/enable-brand-user',
  disableBrandUser: baseURL + '/profile-master-services/private/disable-brand-user',
  enableUser: baseURL + '/profile-master-services/private/enable-user',
  disableBrand: baseURL + '/profile-master-services/private/disable-brand',
  enableBrand: baseURL + '/profile-master-services/private/enable-brand',
  getAllUsers: baseURL + '/profile-master-services/private/fetch-brand-users',
  getReferAndEarn: baseURL + '/profile-master-services/private/refer-and-earn-data',
  getReferAndEarnCheckReferralCode: baseURL + '/profile-master-services/private/refer-and-earn-check-referral-code',
  confirmReferAndEarnReferralCode: baseURL + '/profile-master-services/private/refer-and-earn-confirm-referral-code',
  deleteUser: baseURL + '/profile-master-services/private/delete-user',
  removeUserFromOrg: baseURL + '/profile-master-services/private/remove-user-from-org',
  removeFromBrand: baseURL + '/profile-master-services/private/remove-user-from-brand',
  createNewRole: baseURL + '/profile-master-services/private/create-new-role',
  updateRole: baseURL + '/profile-master-services/private/update-role',
  createNewUser: baseURL + '/profile-master-services/private/send-invite-create-account',
  updateUser: baseURL + '/profile-master-services/private/update-user-role',
  deleteRole: baseURL + '/profile-master-services/private/delete-role',
  getOrgUsers: baseURL + '/profile-master-services/private/fetch-org-users',
  updateOrg: baseURL + '/profile-master-services/private/update-org-details',
  deleteOrg: baseURL + '/profile-master-services/private/delete-org',
  createOrg: baseURL + '/profile-master-services/private/create-org',
  createBrand: baseURL + '/profile-master-services/private/create-brand',
  newRoleInit: baseURL + '/profile-master-services/private/new-role-init',
  newUserInit: baseURL + '/profile-master-services/private/new-user-init',
  createUserFromToken: baseURL + '/profile-master-services/public/create-user-invite-account',
  getAllPendingInvites: baseURL + '/profile-master-services/private/get-all-pending-invites',
  deleteInvite: baseURL + '/profile-master-services/private/delete-invite',
  resendInvite: baseURL + '/profile-master-services/private/resend-invite',
  fetchBrandInfo: baseURL + '/profile-master-services/private/fetch-brand-info',
  fetchOrgInfo: baseURL + '/profile-master-services/private/fetch-org-info',
  fetchOrgAdmins: baseURL + '/profile-master-services/private/fetch-org-admins',
  deleteMe: baseURL + '/profile-master-services/private/delete-me',
  getDomainDetails: baseURL + '/profile-master-services/public/get-domain-details',
  getBrandingDetails: baseURL + '/profile-master-services/private/get-branding-details',
  getCustomEmailDetails: baseURL + '/profile-master-services/private/get-custom-email-details',
  saveCustomEmailDetails: baseURL + '/profile-master-services/private/save-custom-email-details',
  sendSampleCustomEmail: baseURL + '/profile-master-services/private/send-sample-email-from-custom-email',
  deleteCustomEmailDetails: baseURL + '/profile-master-services/private/delete-custom-email',
  saveDomainDetails: baseURL + '/profile-master-services/private/save-domain-details',
  updateBrandingDetails: baseURL + '/profile-master-services/private/update-branding',
  getAllMedia: baseURL + '/image-server/private/fetch-user-media',
  deleteMedia: baseURL + '/profile-master-services/private/delete-media',
  getNotificationSetting: baseURL + '/notification-services/get-notification-settings',
  saveNotificationSetting: baseURL + '/notification-services/save-notification-settings',
  getGeneratedPost: baseURL + '/integration-services/get-generated-post',
  getAiSuggestion: baseURL + '/integration-services/get-ai-suggestion',
  createAiAssistant: baseURL + '/integration-services/create-ai-assistant',
  fetchBrandMedia: baseURL + '/image-server/private/fetch-brand-media',
  uploadAiContent: baseURL + '/integration-services/upload-ai-content',
  deleteAiContent: baseURL + '/integration-services/delete-ai-suggestion',
  deleteAiThread: baseURL + '/integration-services/delete-ai-thread',
  getAiSuggestionMessage: baseURL + '/integration-services/get-ai-suggestion-message',
  generateSemiAutoPost: baseURL + '/integration-services/generate-semi-auto-post',
  getSemiAutoPostStatus: baseURL + '/integration-services/get-semi-auto-post-status',
  getPendingApprovals: baseURL + '/integration-services/get-unapproved-post',
  getOrgPendingApprovals: baseURL + '/integration-services/get-org-unapproved-post',
  getRejectedApprovals: baseURL + '/integration-services/get-rejected-post',
  getOrgRejectedApprovals: baseURL + '/integration-services/get-org-rejected-post',
  getEllapsedApprovals: baseURL + '/integration-services/get-elapsed-post',
  getOrgEllapsedApprovals: baseURL + '/integration-services/get-org-elapsed-post',
  approvePost: baseURL + '/integration-services/approve-post',
  orgApprovePost: baseURL + '/integration-services/org-approve-post',
  approveAllGeneratedPost: baseURL + '/integration-services/approve-all-generated-post',
  approveGeneratedPost: baseURL + '/integration-services/approve-generated-post',
  unApprovePost: baseURL + '/integration-services/unapproved-post',
  orgUnApprovePost: baseURL + '/integration-services/org-unapproved-post',
  retryPost: baseURL + '/integration-services/retry-post',
  orgRetryPost: baseURL + '/integration-services/org-retry-post',
  retryPostRequest: baseURL + '/integration-services/retry-post-request',
  orgRetryPostRequest: baseURL + '/integration-services/org-retry-post-request',
  rejectPost: baseURL + '/integration-services/reject-post',
  orgRejectPost: baseURL + '/integration-services/org-reject-post',
  getDashboardData: baseURL + '/integration-services/get-dashboard-details',
  addCName: baseURL + '/profile-master-services/private/add-cname',
  verifyCName: baseURL + '/profile-master-services/private/verify-cname',
  deleteCName: baseURL + '/profile-master-services/private/delete-cname',
  initApplication: baseURL + '/profile-master-services/public/init-application',
  changeTimeZone: baseURL + '/profile-master-services/private/change-timezone',
  getCurrentSubscription: baseURL + "/payment-services/get-current-plan-details",
  getAddonUpgradePrice: baseURL + "/payment-services/add-on-upgrade",
  addStartTrail: baseURL + "/payment-services/add-start-trail",
  getAddonDowngradePrice: baseURL + "/payment-services/add-on-downgrade",
  changePlanPrice: baseURL + "/payment-services/change-plan",
  updateAppSumoAccount: baseURL + "/profile-master-services/public/upgrade-appsumo-account",
  getUnapprovedPostPublic: baseURL + "/integration-services-public/get-unapproved-post",
  getRejectedPostPublic: baseURL + "/integration-services-public/get-rejected-post",
  getElapsedPostPublic: baseURL + "/integration-services-public/get-elapsed-post",
  getCalendarEventsPublic: baseURL + "/integration-services-public/calendar-events",
  getApprovedCalendarEventsPublic: baseURL + "/integration-services-public/approved-calendar-events?from=",
  getFailedCalendarEventsPublic: baseURL + "/integration-services-public/failed-calendar-events?from=",
  approvePostPublic: baseURL + "/integration-services-public/approve-post",
  unApprovePostPublic: baseURL + "/integration-services-public/unapproved-post",
  rejectPostPublic: baseURL + "/integration-services-public/reject-post",
  shareApprovalPosts: baseURL + "/integration-services/share-approval-posts",
  removeApprovalPosts: baseURL + "/integration-services/remove-share-approval-posts",
  getShareApprovalPosts: baseURL + "/integration-services/get-share-approval-posts",
  getOnboardingInfoFromWebsite: baseURL + "/integration-services/get-onboarding-info-from-website",
  saveOnBoardingInfo: baseURL + "/profile-master-services/private/save-org-info",
  getAllAutomation: baseURL + '/integration-services/get-all-automation',
  createAutomation: baseURL + '/integration-services/create-automation',
  editAutomation: baseURL + '/integration-services/edit-automation-post',
  deleteAutomation: baseURL + '/integration-services/delete-automation-post',
  FetchAutomationPostView: baseURL + '/integration-services/fetch-automation-post-view?automation_post_id=',
  limitBrand: baseURL + '/profile-master-services/private/limit-brand-data',
  checkResellerTokenIsValid: baseURL + '/profile-master-services/public/login-reseller-api-code',
  getAPIKey: baseURL + '/profile-master-services/private/get-api-key',
  generateAPIKey: baseURL + '/profile-master-services/private/generate-api-key',
  deleteAPIKey: baseURL + '/profile-master-services/private/delete-api-key',
  setAffiliate: baseURL + '/website-service/public/set-affiliate',
  couponUpdate: baseURL + '/profile-master-services/private/upgrade-to-lifetime-account',
  enableAPI: baseURL + '/profile-master-services/private/enable-api',
  enableReseller: baseURL + '/profile-master-services/private/enable-reseller',
  disableReseller: baseURL + '/profile-master-services/private/disable-reseller',
  addAccessToken: baseURL + '/profile-master-services/public/add-access-token',
  getLanguageJson: baseURL + '/profile-master-services/public/language',
};

export const postsModuleURL = {


  startAutoPost: baseURL + '/integration-services/start-auto-post',
  getAutoPostDetails: baseURL + '/integration-services/get-auto-post-details',
  updateAutoPostDetails: baseURL + '/integration-services/update-auto-post-details',
  pauseAutoPostDetails: baseURL + '/integration-services/pause-auto-post',
  resumeAutoPostDetails: baseURL + '/integration-services/resume-auto-post',
  deleteAutoPostDetails: baseURL + '/integration-services/delete-auto-post',
  getAIAutoPilotV2Configuration: baseURL + '/integration-services/ai-auto-pilot-v2/configuration',
  saveAIAutoPilotV2Configuration: baseURL + '/integration-services/ai-auto-pilot-v2/configuration',
  analyzeAIAutoPilotV2Website: baseURL + '/integration-services/ai-auto-pilot-v2/analyze-website',
  generateAIAutoPilotV2: baseURL + '/integration-services/ai-auto-pilot-v2/generate-and-schedule',
  pauseAIAutoPilotV2: baseURL + '/integration-services/ai-auto-pilot-v2/pause',
  resumeAIAutoPilotV2: baseURL + '/integration-services/ai-auto-pilot-v2/resume',
  deleteAIAutoPilotV2: baseURL + '/integration-services/ai-auto-pilot-v2/delete',


  facebookPosts: baseURL + '/facebook-services/get-published-posts?id=',
  facebookReels: baseURL + '/facebook-services/get-published-reels?id=',
  facebookStories: baseURL + '/facebook-services/get-published-stories?id=',
  facebookNextPosts: baseURL + '/facebook-services/get-next-published-posts?id=',
  instagramPosts: baseURL + '/instagram-services/get-published-posts?id=',
  instagramStory: baseURL + '/instagram-services/get-published-stories?id=',
  instagramNextPosts: baseURL + '/instagram-services/get-next-published-posts?id=',
  uploadPosts: baseURL + '/integration-services/publish-new-post',
  uploadOrgPosts: baseURL + '/integration-services/publish-org-level-new-post',
  uploadBulkPosts: baseURL + '/integration-services/bulk-new-post',
  twitterPosts: baseURL + '/twitter-services/get-published-posts?id=',
  youtubePosts: baseURL + '/youtube-services/get-published-posts?id=',
  pinterestPosts: baseURL + '/pinterest-services/get-published-posts?id=',
  linkedInPosts: baseURL + '/linkedin-services/page/get-published-posts?id=',
  tiktokPosts: baseURL + '/tiktok-services/get-published-posts?id=',
  threadsPosts: baseURL + '/threads-services/get-published-posts?id=',
  snapchatPosts: baseURL + '/snapchat-services/get-published-posts?id=',
  snapchatSavedStories: baseURL + '/snapchat-services/get-published-saved-story?id=',
  snapchatSportlights: baseURL + '/snapchat-services/get-published-sportlights?id=',
  blueskyPosts: baseURL + '/bluesky-services/get-published-posts?id=',
  googlemybusinessPosts: baseURL + '/gbusiness-services/get-published-posts?id=',
  saveDraft: baseURL + '/integration-services/save-draft',
  orgSaveDraft: baseURL + '/integration-services/org-save-draft',
  savePostAsDraft: baseURL + '/integration-services/save-post-as-draft',
  orgSavePostAsDraft: baseURL + '/integration-services/org-save-post-as-draft',
  loadDraft: baseURL + '/integration-services/get-saved-draft',
  orgLoadDraft: baseURL + '/integration-services/get-org-saved-draft',
  getCalendarEvents: baseURL + '/integration-services/calendar-events?from=',
  getOrgCalendarEvents: baseURL + '/integration-services/org-calendar-events?from=',
  getApprovedCalendarEvents: baseURL + '/integration-services/approved-calendar-events?from=',
  getOrgApprovedCalendarEvents: baseURL + '/integration-services/org-approved-calendar-events?from=',
  scheduledEventInfo: baseURL + '/integration-services/scheduled-event-info?schedule_post_id=',
  orgFailedScheduledEventInfo: baseURL + '/integration-services/org-failed-scheduled-event-info?schedule_post_id=',
  orgScheduledEventInfo: baseURL + '/integration-services/org-scheduled-event-info?schedule_post_id=',
  getPublicScheduledEventInfo: baseURL + '/integration-services-public/scheduled-event-info?schedule_post_id=',
  addPublicCommentToScheduledEventInfo: baseURL + '/integration-services-public/add-comment-on-scheduled-event?url_key=',
  addCommentToScheduledEventInfo: baseURL + '/integration-services/add-comment-on-scheduled-event',
  addPublicReplyCommentToScheduledEventInfo: baseURL + '/integration-services-public/reply-to-comment-on-scheduled-event?url_key=',
  addReplyCommentToScheduledEventInfo: baseURL + '/integration-services/reply-to-comment-on-scheduled-event',
  deleteDraft: baseURL + '/integration-services/delete-draft?id=',
  orgDeleteDraft: baseURL + '/integration-services/org-delete-draft?id=',
  deleteSchedule: baseURL + '/integration-services/delete-scheduled-event?schedule_post_id=',
  deleteSchedules: baseURL + '/integration-services/delete-scheduled-events',
  deleteOrgSchedule: baseURL + '/integration-services/delete-org-scheduled-event?schedule_post_id=',
  reScheduleNewPost: baseURL + '/integration-services/reschedule-new-post',
  orgReScheduleNewPost: baseURL + '/integration-services/org-reschedule-new-post',
  updateScheduledPost: baseURL + '/integration-services/update-new-post',
  updateOrgScheduledPost: baseURL + '/integration-services/update-org-level-new-post',
  getFacebookPostDetails: baseURL + '/facebook-services/get-post-details?connected_profile_id=',
  getFacebookReelsDetails: baseURL + '/facebook-services/get-reels-details?connected_profile_id=',
  getFacebookStoryDetails: baseURL + '/facebook-services/get-story-details?connected_profile_id=',
  getIntagramPostDetails: baseURL + '/instagram-services/get-post-details?connected_profile_id=',
  getIntagramStoryDetails: baseURL + '/instagram-services/get-story-details?connected_profile_id=',
  getTiktokPostDetails: baseURL + '/tiktok-services/get-post-details?connected_profile_id=',
  getThreadsPostDetails: baseURL + '/threads-services/get-post-details?connected_profile_id=',
  snapchatPostDetails: baseURL + '/snapchat-services/get-post-details?connected_profile_id=',
  snapchatSavedStoryDetails: baseURL + '/snapchat-services/get-saved-story-details?connected_profile_id=',
  snapchatSportlightDetails: baseURL + '/snapchat-services/get-sportlight-details?connected_profile_id=',
  getBlueskyPostDetails: baseURL + '/bluesky-services/get-post-details?connected_profile_id=',
  getTwitterPostDetails: baseURL + '/twitter-services/get-post-details?connected_profile_id=',
  getYoutubePostDetails: baseURL + '/youtube-services/get-post-details?connected_profile_id=',
  getPinterestPostDetails: baseURL + '/pinterest-services/get-post-details?connected_profile_id=',
  getYoutubeNextReply: baseURL + '/youtube-services/get-more-replies?connected_profile_id=',
  getLinkedinPostDetails: baseURL + '/linkedin-services/page/get-post-details?connected_profile_id=',
  getNextLinkedinPostDetails: baseURL + '/linkedin-services/page/get-more-replies?connected_profile_id=',
  getFacebookNextComments: baseURL + '/facebook-services/get-more-comments?connected_profile_id=',
  getFacebookNextReply: baseURL + '/facebook-services/get-more-replies?connected_profile_id=',
  getInstagramNextComments: baseURL + '/instagram-services/get-more-comments?connected_profile_id=',
  getInstagramNextReply: baseURL + '/instagram-services/get-more-replies?connected_profile_id=',
  likeFacebookPost: baseURL + '/facebook-services/add-like',
  unlikeFacebookPost: baseURL + '/facebook-services/remove-like',
  addFacebookComment: baseURL + '/facebook-services/add-comment',
  addYoutubeComment: baseURL + '/youtube-services/add-comment',
  addInstagramComment: baseURL + '/instagram-services/add-comment',
  addInstagramRepliesComment: baseURL + '/instagram-services/add-reply-comment',
  addYoutubeRepliesComment: baseURL + '/youtube-services/add-reply-comment',
  addLinkedinComments: baseURL + '/linkedin-services/page/add-comment',
  addLinkedinRepliesComments: baseURL + '/linkedin-services/page/add-reply-comment',
  deleteFacebookCommentAndMessage: baseURL + '/facebook-services/delete',
  deleteInstagramCommentAndMessage: baseURL + '/instagram-services/delete',
  deleteYoutubeCommentAndMessage: baseURL + '/youtube-services/delete',
  deleteLinkedinCommentAndMessage: baseURL + '/linkedin-services/page/delete',
  addRemoveLikeYoutube: baseURL + '/youtube-services/add-remove-like',
  fetchAllReviews: baseURL + '/gbusiness-services/get-all-review?id=',
  addReviews: baseURL + '/gbusiness-services/add-review',
  addAnswer: baseURL + '/gbusiness-services/add-answer',
  deleteReviews: baseURL + '/gbusiness-services/delete-review',
  deleteAnswers: baseURL + '/gbusiness-services/delete-answer',
  fetchAllQuestions: baseURL + '/gbusiness-services/get-all-questions?id=',
  addLinkedinCommentLike: baseURL + '/linkedin-services/page/add-comment-like',
  addLinkedinPostLike: baseURL + '/linkedin-services/page/add-post-like',
  deleteLinkedinCommentLike: baseURL + '/linkedin-services/page/delete-comment-like',
  deleteLinkedinPostLike: baseURL + '/linkedin-services/page/delete-post-like',
  generateImage: baseURL + '/integration-services/generate-ai-image',
  aiEditImage: baseURL + '/integration-services/edit-ai-image',
  getBrandPreference: baseURL + '/integration-services/get-ai-image-generation-details',
  generateAIPrompt: baseURL + '/integration-services/generate-ai-image-prompt'
};

export const internalReportModuleURL = {
  scheduledReports: baseURL + '/report-services/scheduled-reports?service_name=',
  fetchSubReports: baseURL + '/report-services/fetch-sub-reports?report_id=',
  fetchCustomReport: baseURL + '/report-services/fetch-custom-report?custom_report_id=',
}
export const reportModuleURL = {
  facebookAudienceSummary: baseURL + '/facebook-services/get-predefined-report',
  instagramAudienceSummary: baseURL + '/instagram-services/get-predefined-report',
  youtubeAudienceSummary: baseURL + '/youtube-services/get-predefined-report',
  linkedinAudienceSummary: baseURL + '/linkedin-services/page/get-predefined-report',
  exportReport: baseURL + '/integration-services/export-report',
  sendAsEmailReport: baseURL + '/integration-services/email-export-report',
  scheduledReport: baseURL + '/integration-services/scheduled-export-report',
  addScheduledReport: baseURL + '/integration-services/create-scheduled-report',
  fetchPredefinedAndCustomReports: baseURL + '/integration-services/fetch-predefined-and-custom-reports',
  editScheduledReport: baseURL + '/integration-services/edit-scheduled-report',
  deleteScheduledReport: baseURL + '/integration-services/delete-scheduled-report',
  getAllScheduledReport: baseURL + '/integration-services/get-all-scheduled-reports',
  fetchReportDetails: baseURL + '/integration-services/fetch-report-details',
  fetchCustomReports: baseURL + '/integration-services/fetch-custom-reports',
  createCustomReport: baseURL + '/integration-services/create-custom-report',
  updateCustomReport: baseURL + '/integration-services/edit-custom-report',
  updateCardOrder: baseURL + '/integration-services/update-card-order',
  deleteCustomReport: baseURL + '/integration-services/delete-custom-report',
  addCustomReportCard: baseURL + '/integration-services/add-custom-report-card',
  deleteCustomReportCard: baseURL + '/integration-services/delete-custom-report-card',
};
export const crmModuleURL = {
  fetchWebhookMessage: baseURL + '/integration-services/fetch-webhook-message?service_name=',
  exportWebhookMessage: baseURL + '/integration-services/export-webhook-messages-to-csv?service_name=',
  exportWebhookMessageExcel: baseURL + '/integration-services/export-webhook-messages-to-excel?service_name=',
  updateWebhookMessage: baseURL + '/integration-services/update-webhook-message',
  getCRMAccounts: baseURL + '/integration-services/webhook-subscrption-profiles',
  getNotCrmAccounts: baseURL + '/integration-services/webhook-not-subscrption-profiles',
  subscribeWebhookEvent: baseURL + '/integration-services/subscribe-webhook-event',
  enableWebhookAccounts: baseURL + '/integration-services/enable-webhook-accounts',
  disableWebhookAccounts: baseURL + '/integration-services/disable-webhook-accounts',
  deleteWebhookAccounts: baseURL + '/integration-services/delete-webhook-accounts',
  saveAutomationTrigger: baseURL + '/integration-services/save-auto-dm-details',
  fetchAutomationTrigger: baseURL + '/integration-services/fetch-automation-triggers-details',
  deleteAutomationTrigger: baseURL + '/integration-services/delete-automation-triggers',
  enableAutomationTrigger: baseURL + '/integration-services/enable-automation-triggers',
  disableAutomationTrigger: baseURL + '/integration-services/disable-automation-triggers',
  updateAutomationTrigger: baseURL + '/integration-services/update-automation-triggers',
};
export const chatModuleURL = {
  //FacebookConversation
  getAllFacebookMessageConversations: baseURL + '/facebook-services/get-all-messages?page_id=',
  getFacebookMessageConversation: baseURL + '/facebook-services/get-conversation-message?page_id=',
  sendMessage: baseURL + '/facebook-services/add-message',
  getAllInstagramMessageConversations: baseURL + '/instagram-services/get-all-messages?page_id=',
  getInstagramMessageConversation: baseURL + '/instagram-services/get-conversation-message?page_id=',
  sendInstagramMessage: baseURL + '/instagram-services/add-message'
}

export const integrateModuleURL = {
  //Facebook integration
  facebookIntegration: baseURL + '/facebook-services/integrate',
  getFacebookPagesAndGroups: baseURL + '/facebook-services/get-groups-and-pages',
  fetchNextFacebookPagesAndGroups: baseURL + '/facebook-services/fetch-next-pages',
  integrateFacebookPagesAndGroups: baseURL + '/facebook-services/integrate-pages-and-groups',
  getConnectedNetworks: baseURL + '/integration-services/connected-profiles',
  getOrgConnectedNetworks: baseURL + '/integration-services/org-connected-profiles',
  getAutomationConnectedNetworks: baseURL + '/integration-services/automation-connected-profiles',
  getReportsDetails: baseURL + '/integration-services/get-all-reports?service_name=',
  updateFacebookAccounts: baseURL + '/facebook-services/update-account',
  reAuthenticateFacebookPagesAndGroups: baseURL + '/facebook-services/re-authenticate-account',
  reAuthenticateAllFacebookAndInstagram: baseURL + '/facebook-services/re-authenticate-all-account',

  //Twitter Integration
  twitterIntegration: baseURL + '/twitter-services/integrate',
  twitterDeveloperIntegration: baseURL + '/twitter-services/developer-new-integrate',
  sendTwitterAccessToken: baseURL + '/twitter-services/save-access-token',
  sendDeveloperTwitterAccessToken: baseURL + '/twitter-services/developer-save-access-token',
  sendDevelopeReAuthenticateTwitter: baseURL + '/twitter-services/developer-re-authenticate-account',
  updateTwitterAccounts: baseURL + '/twitter-services/update-account',
  reAuthenticateTwitter: baseURL + '/twitter-services/re-authenticate-account',

  //bluesky Integration
  blueskyIntegration: baseURL + '/bluesky-services/integrate-account',
  updateBlueskyAccounts: baseURL + '/bluesky-services/update-account',
  reAuthenticateBluesky: baseURL + '/bluesky-services/re-authenticate-account',

  //Youtube Integration
  sendYoutubeAccessToken: baseURL + '/youtube-services/save-access-token',
  reAuthenticateYoutube: baseURL + '/youtube-services/re-authenticate-account',
  updateYoutubeAccounts: baseURL + '/youtube-services/update-account',

  //Pinterest Integration
  sendPinterestAccessToken: baseURL + '/pinterest-services/save-access-token',
  reAuthenticatePinterest: baseURL + '/pinterest-services/re-authenticate-account',
  updatePinterestAccounts: baseURL + '/pinterest-services/update-account',
  FetchAllBoards: baseURL + '/pinterest-services/fetch-all-boards?id=',
  FetchBatchBoards: baseURL + '/pinterest-services/fetch-batch-boards',
  CreateBoard: baseURL + '/pinterest-services/create-boards',

  senSnapChatAccessToken: baseURL + '/snapchat-services/save-access-token',
  reAuthenticateSnapChat: baseURL + '/snapchat-services/re-authenticate-account',
  updatSnapChatAccounts: baseURL + '/snapchat-services/update-account',

  //Instagram Integration
  sendInstagramAuthorizationCode: baseURL + '/instagram-services/save-access-token',
  getInstagramAccountsFromToken: baseURL + '/instagram-services/get-instagram-account-from-token',
  fetchNextInstagramPagesAndGroups: baseURL + '/instagram-services/fetch-next-pages',
  integrateInstagram: baseURL + '/instagram-services/integrate-instagram',
  updateInstagramAccounts: baseURL + '/instagram-services/update-account',
  reAuthenticateInstagramAccounts: baseURL + '/instagram-services/re-authenticate-account',
   sendDirectInstagramAuthorizationCode: baseURL + '/instagram-services/direct/save-access-token',
   directUpdateInstagramAccounts: baseURL + '/instagram-services/direct/update-account',
   directReAuthenticateInstagramAccounts: baseURL + '/instagram-services/direct/re-authenticate-account',

  //LinkedIn Integration
  sendLinkedInAccessToken: baseURL + '/linkedin-services/profile/save-access-token',
  sendLinkedInPageAccessToken: baseURL + '/linkedin-services/page/save-access-token',
  getLinkedInPages: baseURL + '/linkedin-services/page/get-linked-pages',
  reAuthenticateLinkedInPages: baseURL + '/linkedin-services/page/re-authenticate-account',
  reAuthenticateLinkedInProfile: baseURL + '/linkedin-services/profile/re-authenticate-account',
  updateLinkedinAccounts: baseURL + '/linkedin-services/update-account',

  //Tiktok Integration
  sendTiktokAccessToken: baseURL + '/tiktok-services/save-access-token',
  reAuthenticateTiktok: baseURL + '/tiktok-services/re-authenticate-account',
  updateTiktokAccounts: baseURL + '/tiktok-services/update-account',

  //GoogleMyBusiness Integration
  sendGoogleMyBusinessAccessToken: baseURL + '/gbusiness-services/save-access-token',
  fetchGoogleMyBusinessNextPages: baseURL + '/gbusiness-services/fetch-next-pages',
  integrateGoogleMyBusinessAccessToken: baseURL + '/gbusiness-services/integrate-pages',
  updateGbusinessAccounts: baseURL + '/gbusiness-services/update-account',
  reAuthenticateGoogleMyBusiness: baseURL + '/gbusiness-services/re-authenticate-account',
  getPhoneNumber: baseURL + '/gbusiness-services/get-phone-number?id=',

  //Threads Integration
  sendThreadsAccessToken: baseURL + '/threads-services/save-access-token',
  updateThreadsAccounts: baseURL + '/threads-services/update-account',
  reAuthenticateThreads: baseURL + '/threads-services/re-authenticate-account',

  //Accounts
  disintegrateAccounts: baseURL + '/integration-services/disintegrate-accounts',
  enableSocialAccounts: baseURL + '/integration-services/enable-accounts',
  disableSocialAccounts: baseURL + '/integration-services/disable-accounts',

  //Post
  getScheduledPost: baseURL + '/integration-services/get-scheduled-post',
  getFailedPost: baseURL + '/integration-services/failed-calendar-events?from=',
  getOrgFailedPost: baseURL + '/integration-services/org-failed-calendar-events?from=',

  handleContactUs: baseURL + '/profile-master-services/public/contact-us',
  addUserAffiliate: baseURL + '/profile-master-services/private/add-user-affiliate',

  //AI
  checkAndGetAICredit: baseURL + '/profile-master-services/private/check-and-get-ai-credit',
  checkAIEnabledForThisBrand: baseURL + '/profile-master-services/private/check-custom-ai-enabled',
  generateAIContent: baseURL + '/profile-master-services/private/generate-ai-content',
  generateHashtag: baseURL + '/profile-master-services/private/generate-ai-hashtags',
  getAllImageModels: baseURL + '/integration-services/get-all-image-models'
};

export const paymentModuleUrl = {
  createPayment: baseURL + '/payment-services/change-plan-payment',
  checkPayment: baseURL + '/payment-services/check-payment?payment_intent=',
  addonPayment: baseURL + '/payment-services/add-on-upgrade-payment',
  getForNextBill: baseURL + '/payment-services/pay-for-next-bill',
  payForNextBill: baseURL + '/payment-services/pay-for-next-bill-payment',
  downGradePayment: baseURL + '/payment-services/add-on-downgrade-payment',
};

export const imageModeuleUrl = {
  uploadMedia: baseURL + '/image-server/upload-media',
  uploadPrivateMedia: baseURL + '/image-server/private/upload-media',
  fetchMediaMetadata: baseURL + '/image-server/fetch-media-metadata',
  fetchPrivateMediaMetadata: baseURL + '/image-server/fetch-private-media-metadata',
  deleteMedia: baseURL + '/image-server/private/delete-media',
  uploadMediaFromUrl: baseURL + '/image-server/upload-media-from-url'
}

export const demoModuleUrl = {
  getDemoJson: baseURL + '/demo-service/private/get-demo-json',
}

export const errorModuleUrl = {
  logError: baseURL + '/profile-master-services/public/ui-error-log',
}

export const competitorModuleURL = {
  list: baseURL + '/integration-services/competitors',
  add: baseURL + '/integration-services/competitors/add',
  refresh: baseURL + '/integration-services/competitors/refresh',
  source: baseURL + '/integration-services/competitors/source',
  remove: baseURL + '/integration-services/competitors/remove',
  search: baseURL + '/integration-services/competitors/search',
};
